import artifact from '$houdini/artifacts/UpdateInventoryOption'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateInventoryOptionStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
